export default __webpack_public_path__ + "static/media/tempStore6.307dd3b8.png";